import { Icon } from '@tallink/components-lib'
import classNames from 'classnames'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import { isGiftCardsMode as isGiftCardsModeSelector } from '../../selectors/selectors'
import MorePropTypes from '../../utils/MorePropTypes'
import s from './Route.module.scss'

export default function Route(props) {
  return (
    <div className={classNames(s.route, props.className)}>
      <Icon className={s.icon} type="ship-front" />
      <h2 className={s.ports}>
        <RouteText {...props} />
      </h2>
    </div>
  )
}

Route.propTypes = MorePropTypes.fromTo

export function RouteForSummary(props) {
  return (
    <div className={classNames(s['route-for-summary'])}>
      <RouteText {...props} />
    </div>
  )
}

RouteForSummary.propTypes = MorePropTypes.fromTo

function RouteText({ from, to }) {
  const isGiftCardsMode = useSelector(isGiftCardsModeSelector)
  const { t } = useTranslation()
  const portFromName = t(`port.${from}`)
  const portToName = t(`port.${to}`)

  if (isGiftCardsMode) return <div className={s.text}>{t('mainPage.title.GIFT_CARDS')}</div>

  return (
    <div className={s.text}>
      <span>
        {portFromName}
        <span className={s.arrow}>→</span>
      </span>
      <span>
        {portToName}
        <span className={s.divider}>/</span>
      </span>
      <span>
        {portToName}
        <span className={s.arrow}>→</span>
      </span>
      <span>{portFromName}</span>
    </div>
  )
}

RouteText.propTypes = MorePropTypes.fromTo
